import SelectOption from '@/store/dict/selectOptionDict'
import { configFun } from './config.js'
import {
  addLeasingSchemeConfig,
  editLeasingSchemeConfig,
  getLeasingSchemeConfigDetail,
} from '@/api/purchaseAndSaleAPI'
import { MODE_TYPE } from '../const'

export default {
  data() {
    const {
      baseRules,
      configDefaultValue,
    } = configFun.call(this)
    return {
      baseRules,
      configDefaultValue,
      lessMonthCloumn: [
        {
          type: 'select',
          label: '日租金规则',
          key: 'dailyRule',
          source: SelectOption.dailyRentRules,
          options: {
            clearable: true,
            bottomText: '·首期租金以日租金乘以首期天数计算',
          },
        },
        {
          type: 'text',
          label: '尾期租金规则',
          key: 'lastPeriodRuleName',
        },
      ],
      fromPath: '',
      rentPeriodType: 'select',
      id: '',
      oLoading: {
        pageLoading: true,
        submit: false,
      },
      orderPlanFeeList: [],
      // 阶梯配置 默认两个阶梯
      ladderSchemeConfig: {
        isOpen: 0,
        unit: 1,
        clickNumber: 0,
        ladderSchemeList: [
          {
            startMonth: 1, // 开始时间为1
            endMonth: '',
            amount: '',
          },
          {
            startMonth: '',
            endMonth: '',
            amount: '',
          },
        ],
      },
      postParams: {}, // 提交表单数据
    }
  },
  // 利用路由钩子函数获取，此函数会在vue实列创建之前调用，故不能在此函数内调用this
  beforeRouteEnter(_, from, next) {
    next((vm) => {
      vm.fromPath = from.path
    })
  },
  mounted() {
    this.pageConfig()
  },
  methods: {
    // 页面基本判断
    pageConfig() {
      setTimeout(() => {
        this.oLoading.pageLoading = false
      }, 1500)
      if (this.mode === MODE_TYPE.ADD) {
        return false
      }
      this.id = this.$route.query.id
      if (!this.id) {
        this.$message.error('url缺少ID参数')
        return false
      }
      this.getDetail()
    },
    // 新增操作
    addLeasingSchemeConfigFun() {
      this.oLoading.submit = true
      const params = {
        ...this.postParams,
      }
      // 集团侧 & 从新增产品跳转过来带的 goUpState 参数的，添加 state ，可使得方案直接上架，保证从此页面再跳转回新增商品的时候，在选择租赁方案的时候可以选择上
      if (this.$route.query.goUpState) {
        params.state = 10
      }
      addLeasingSchemeConfig(params)
        .then(({ code }) => {
          if (code === 1) {
            this.$message.success('添加成功')
            this.goPageBacks(true)
          }
        })
        .finally(() => {
          this.oLoading.submit = false
        })
    },
    // 编辑操作
    editLeasingSchemeConfigFun() {
      this.oLoading.submit = true
      const params = {
        id: this.id,
        ...this.postParams,
      }
      if (!this.postParams.maintenancePlanId) {
        params.maintenancePlanId = 0
      }
      editLeasingSchemeConfig(params)
        .then(({ code }) => {
          if (code === 1) {
            this.$message.success('修改成功')
            this.goPageBacks(true)
          }
        })
        .finally(() => {
          this.oLoading.submit = false
        })
    },
    // 编辑获取详情
    async getDetail() {
      this.oLoading.submit = true
      const { code, data } = await getLeasingSchemeConfigDetail({ id: this.id }).finally(() => {
        this.oLoading.submit = false
      })
      if (code === 1) {
        this.setData(data)
      }
    },

    getJsonQuery() {
      let query
      try {
        query = JSON.parse(this.$route.query.redirectQuery)
      } catch (e) {
        query = null
      }
      return query
    },
    // 页面返回
    goPageBacks(status = false) {
      const { redirectPathName } = this.$route.query
      if (redirectPathName) {
        const _query = this.getJsonQuery()
        this.$refreshBack(status) // 关闭当前tab
        this.$router.push({
          name: redirectPathName,
          query: _query,
        })
      } else if (!this.fromPath || this.fromPath === '/') {
        this.$refreshBack(status) // 关闭当前tab
      } else {
        this.$refreshBack(status) // 关闭当前tab
        this.$router.push({
          path: this.fromPath,
          query: {
            id: this.id,
          },
        })
      }
    },
  },
}
